import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Back from '../Components/back';
import tickIcon from '../Assets/tickIcon.png';
import calendarIcon from '../Assets/calendarIcon.png'
import giftIcon from '../Assets/giftIcon.png'
import getCheckIn from '../Api/getCheckIn';
import checkIn from '../Api/checkIn';
import Swal from 'sweetalert2';
import ModelContact from "../Components/ModelContactUs";

export default function CheckIn() {
	const navigate = useNavigate();
	const [checkInData, setCheckInDataData] = useState(null);
	const [showContactModal, setShowContactModal] = useState(false);
	const [modalContent, setModalContent] = useState(null);

	const Toast = Swal.mixin({
		toast: true,
		position: 'bottom-end',
		showConfirmButton: false,
		timer: 5000,
		timerProgressBar: true,
		didOpen: (toast) => {
			toast.addEventListener('mouseenter', Swal.stopTimer);
			toast.addEventListener('mouseleave', Swal.resumeTimer);
		},
	});

	const openContactModal = () => {
		setShowContactModal(true);
		setModalContent({ title: "Claim Rewards - Get Assistance Now!", content: 'If you wish to claim your rewards, kindly contact our support service.' });
	};

	const closeContactModal = () => {
		setShowContactModal(false);
		setModalContent(null);
	};

	const fetchDataInfo = async () => {
		try {
			const response = await getCheckIn();
			setCheckInDataData(response.data.data);
		} catch (error) {
			console.error('API Error:', error.message);
            if (error.response.status === 401 || error.response.status === 500){
                Toast.fire({
					icon: 'error',
					title: error.response.data.title,
				});
				localStorage.clear();
				navigate('/');
			}
			Toast.fire({
				icon: 'error',
				title: error.response.data.message,
			});
		}
	};


	const handleCheckIn = async (checkinDay) => {
		try {
			await checkIn();
			Toast.fire({
				icon: 'success',
				title: 'Check-In Successfully'
			})

			if (checkinDay ===7 ){
				openContactModal();
			}
            fetchDataInfo();
		} catch (error) {
            if (error.response.status === 401 || error.response.status === 500) {
                Toast.fire({
                    icon: 'error',
                    title: error.response.data.title
                })
                localStorage.clear();
                navigate("/");
            }
            Toast.fire({
                icon: 'error',
                title: error.response.data.message
            })
        }
	}


	const showPopUpMsg = () => {
		Toast.fire({
			icon: 'success',
			title: 'Notify Customer Service Now To Claim Your Reward!'
		})
	}

	useEffect(() => {
		fetchDataInfo();
	}, []);

	const formatNumberWithSuffix = (num) => {
		const suffixes = ["st", "nd", "rd"];
		const suffix = num > 3 && num < 21 ? "th" : suffixes[(num - 1) % 10] || "th";
		return `${num}${suffix}`;
	};

	const loopArray = Array.from({ length: 7 }, (_, index) => index + 1);

	const checkInList = checkInData?.checkInList ?? []

	return (
		<>
			<div className="container mobile-page">
				<div className="container">
					<div className="row">
						<div className="col-2 d-flex align-items-center">
							<Back location={"/home"}/>
						</div>
						<div className="col-9 text-center">
							<span className="fs-3 text-white fw-bold">Check -In Schedule</span>
						</div>
						<div className="col-12 text-center mt-5">
							<span className="fs-6 text-white fw-bold ">
								You must complete minimum 2 sets
								<br />
								per day to check-in
							</span>
						</div>
					</div>
				</div>

				<div className="container light-black rounded-3 mt-3">
					<div className="px-2 py-4">
						<div className="mb-3">
						<span className="fs-4 text-white fw-bold mb-4">Daily Check-In</span>
						</div>

						{loopArray.map((index) => (
							<div key={index} className="row align-items-center mt-4">
								<div className= {`col-3 mt-2 text-center ${index === Math.max(...checkInList) + 1 ? 'checked-line' : (checkInList.length === 0 && index === 1) && 'checked-line' }`}>
									<img src={index === 7 ? giftIcon : checkInList.includes(index) ? tickIcon : calendarIcon} width={45} alt="calendarIcon" />
								</div>
								<div className="col-5 d-flex flex-column align-items-start">
									<span className={` fs-6 ${checkInList.includes(index) || index === Math.max(...checkInList) + 1 ? 'fw-bold text-pink' :  index === 1 ? 'fw-bold text-pink' : 'lightGrey'}`}>
									  {formatNumberWithSuffix(index)} Day Check-In
									</span>
									{index === 7 && <span className='text-white fw-bold fs-6 text-start'>+Bonus!</span>}
								</div>
								<div className="col-4 d-flex flex-column">
									{checkInList.includes(index) ? (
										// If the day is in the `checkInList` array, show the completed button
										<button type="button" className={`button-outline rounded-3 completed ${index !== 7 && 'pe-none'}`} onClick={index ===7 && openContactModal}>
											<span className='fw-bold'>{index === 7 ? 'Claim' : 'Done'}</span>
										</button>
									) : (
										index === Math.max(...checkInList) + 1 ? (
											<button
												type="button"
												className='rounded-3 checked py-2'
												onClick={() => handleCheckIn(index)}
											>
												<span className='fw-bold'>Check-In</span>
											</button>
										) : ( index === 1 &&
											<button
												type="button"
												className='rounded-3 checked py-2'
												onClick={() => handleCheckIn(index)}
											>
												<span className='fw-bold'>Check-In</span>
											</button>
										)
									)}
								</div>
							</div>
						))}
					</div>
				</div>

				<div className="container light-black rounded-3 mt-3">
					<div className="px-2 py-4">
						<div className="mb-3">
							<span className="fs-4 text-white fw-bold mb-4">Salary List</span>
						</div>

						<div className="container">
							<div className="row align-items-center mb-3">
								<div className="col-4">
									<span className='text-pink fs-5 fw-bold'>Normal</span>
								</div>
								<div className="col-4 d-flex flex-column">
									<span className='text-white fs-6'>Day 7</span>
									<span className='text-white fs-6 fw-bold'>{checkInData?.salaryList[1].normal}</span>
								</div>
							</div>

							<div className="row align-items-center mb-3">
								<div className="col-4">
									<span className='text-pink fs-5 fw-bold'>Silver</span>
								</div>
								<div className="col-4 d-flex flex-column">
									<span className='text-white fs-6'>Day 7</span>
									<span className='text-white fs-6 fw-bold'>{checkInData?.salaryList[1].silver}</span>
								</div>
							</div>

							<div className="row align-items-center">
								<div className="col-4">
									<span className='text-pink fs-5 fw-bold'>Gold</span>
								</div>
								<div className="col-4 d-flex flex-column">
									<span className='text-white fs-6'>Day 7</span>
									<span className='text-white fs-6 fw-bold'>{checkInData?.salaryList[1].gold}</span>
								</div>
							</div>

						</div>
					</div>
				</div>

				{showContactModal && (
					<ModelContact onClose={closeContactModal} title={modalContent.title} message={modalContent.content} />
				)}

				{/*<div className="mt-5 text-center">*/}
				{/*	<p className="checkInTitle">Salary List</p>*/}
				{/*</div>*/}

				{/*<div className="checkInTab p-4 mt-2 rounded-4 text-white">*/}
				{/*	<table className="table text-white">*/}
				{/*		<tbody>*/}
				{/*		<tr>*/}
				{/*			<th>Member</th>*/}
				{/*			<th>Day 4</th>*/}
				{/*			<th>Day 7</th>*/}
				{/*		</tr>*/}
				{/*		<tr>*/}
				{/*			<td>Normal</td>*/}
				{/*			<td>{startingData?.salaryList[0].normal}</td>*/}
				{/*			<td>{startingData?.salaryList[1].normal}</td>*/}
				{/*		</tr>*/}
				{/*		<tr>*/}
				{/*			<td>Silver</td>*/}
				{/*			<td>{startingData?.salaryList[0].silver}</td>*/}
				{/*			<td>{startingData?.salaryList[1].silver}</td>*/}
				{/*		</tr>*/}
				{/*		<tr>*/}
				{/*			<td>Gold</td>*/}
				{/*			<td>{startingData?.salaryList[0].gold}</td>*/}
				{/*			<td>{startingData?.salaryList[1].gold}</td>*/}
				{/*		</tr>*/}
				{/*		</tbody>*/}
				{/*	</table>*/}
				{/*</div>				<div className="checkInTab p-4 rounded-4 text-white">*/}
				{/*	<div className="checkInBoxTitle rounded-2 text-center py-2">*/}
				{/*		<span className="py-5 text-black">You have check-in for {startingData?.totalCheckInDay} days</span>*/}
				{/*	</div>*/}

				{/*	<div className="row mt-2 checkInIconSection">*/}
				{/*		<div className="col-9">*/}
				{/*			<div className="row mt-2">*/}
				{/*				{[1, 2, 3, 4, 5, 6].map((day) => (*/}
				{/*					<div className="col-4" key={day}>*/}
				{/*						{startingData?.checkInList.length ? (*/}
				{/*							areDaysConsecutive(startingData?.checkInList) ? (*/}
				{/*								startingData?.checkInList.includes(String(day)) ? (*/}
				{/*									day === 4 ? (*/}
				{/*										<>*/}
				{/*											<img src={greenCoinImage} width="40" alt="claim" />*/}
				{/*											<p className="mt-2" style={{ cursor: 'pointer' }} onClick={showPopUpMsg}>Claim</p>*/}
				{/*										</>*/}
				{/*									) : (*/}

				{/*										<>*/}
				{/*											<img src={greenTickIcon} width="40" alt="coin" />*/}
				{/*											<p className="mt-2">Day {day}</p>*/}
				{/*										</>*/}
				{/*									)*/}
				{/*								) : (*/}
				{/*									day === 4 ? (*/}
				{/*										<>*/}
				{/*											<img src={goldCoinImage} width="40" alt="claim" />*/}
				{/*											<p className="mt-2">Day {day}</p>*/}
				{/*										</>*/}
				{/*									) : (*/}
				{/*										<>*/}
				{/*											<img src={greenTickIcon} width="40" alt="tick" />*/}
				{/*											<p className="mt-2">Day {day}</p>*/}
				{/*										</>*/}
				{/*									)*/}
				{/*								)*/}
				{/*							) : (*/}
				{/*								startingData?.checkInList.includes(String(day)) ? (*/}
				{/*									day === 4 ? (*/}
				{/*										<>*/}
				{/*											<img src={goldCoinImage} width="40" alt="claim" />*/}
				{/*											<p className="mt-2">Day {day}</p>*/}
				{/*										</>*/}
				{/*									) : (*/}
				{/*										<>*/}
				{/*											<img src={greenTickIcon} width="40" alt="coin" />*/}
				{/*											<p className="mt-2">Day {day}</p>*/}
				{/*										</>*/}
				{/*									)*/}
				{/*								) : (*/}
				{/*									day === 4 ? (*/}
				{/*										<>*/}
				{/*											<img src={goldCoinImage} width="40" alt="claim" />*/}
				{/*											<p className="mt-2">Day {day}</p>*/}
				{/*										</>*/}
				{/*									) : (*/}
				{/*										<>*/}
				{/*											<img src={tickIcon} width="40" alt="tick" />*/}
				{/*											<p className="mt-2">Day {day}</p>*/}
				{/*										</>*/}
				{/*									)*/}
				{/*								)*/}
				{/*							)*/}
				{/*						) : (*/}
				{/*							day === 4 ? (*/}
				{/*								<>*/}
				{/*									<img src={goldCoinImage} width="40" alt="coin" />*/}
				{/*									<p className="mt-2">Day {day}</p>*/}
				{/*								</>*/}
				{/*							) : (*/}
				{/*								<>*/}
				{/*									<img src={tickIcon} width="40" alt="tick" />*/}
				{/*									<p className="mt-2">Day {day}</p>*/}
				{/*								</>*/}
				{/*							)*/}
				{/*						)}*/}
				{/*					</div>*/}
				{/*				))}*/}
				{/*			</div>*/}
				{/*		</div>*/}
				{/*		<div className="col-3 d-flex flex-column justify-content-center align-items-center">*/}
				{/*			<img src={giftIcon} width="60" alt="tick" />*/}
				{/*			{startingData?.checkInList.length === 7 && startingData.checkInList.every((day, i) => day === String(i + 1)) && <p style={{ cursor: 'pointer' }} onClick={showPopUpMsg}>Claim</p>}*/}
				{/*		</div>*/}
				{/*	</div>*/}
				{/*	<button className="checkInBoxBtn rounded-2 text-center py-2" onClick={handleCheckIn}>*/}
				{/*		<span className="py-5 text-black">Check In</span>*/}
				{/*	</button>*/}
				{/*</div>*/}
			</div >
		</>
	);
}
